export default "__VITE_ASSET__685e5e33__"